import { useEffect } from 'react'

import { makeVar } from '@apollo/client'

import { PHASE } from '@web/libs/constants'

export const QAModeVar = makeVar(false)

const QA_MODE_POSSIBLE_PHASES = ['development', 'qa', 'stage']

const useGlobalQAMode = () => {
  useEffect(() => {
    const isPossibleQAMode = QA_MODE_POSSIBLE_PHASES.includes(PHASE)

    const toggleQAMode = (ev: KeyboardEvent) => {
      if (!isPossibleQAMode) return

      const isQAToggleKey = ev.key === 'q' || ev.key === 'ㅂ'
      if (isQAToggleKey) {
        QAModeVar(!QAModeVar())
      }
    }

    window.document.addEventListener('keypress', toggleQAMode)

    return () => {
      window.document.removeEventListener('keypress', toggleQAMode)
    }
  })
}

export default useGlobalQAMode
